import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const stylesBase = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer',
      marginLeft: 5,
    },
    profile: {
      // color: theme.palette.text.primary,
      color: '#333',
      fontFamily: 'SBSansText-Regular',
      fontWeight: 500,
    },
    logoutButton: {
      color: '#6366F1',
    },
    avatarInner: {
      transition: '.5s ease',
      display: 'none',
      position: 'absolute',
      textAlign: 'center',
      top: 12,
      left: 12,
    },
    avatar: {
      position: 'relative',
      '&:hover': {
        '& > div[role=avatarIcon]': {
          transition: '.5s ease',
          display: 'block',
        },
      },
    },
  });

export const useStyles = makeStyles(theme => ({
  ...stylesBase(theme),
}));
